"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBizType = exports.IAccessChannel = exports.IPlatForm = void 0;
var IPlatForm;
(function (IPlatForm) {
    IPlatForm[IPlatForm["PC"] = 1] = "PC";
    IPlatForm[IPlatForm["H5"] = 2] = "H5";
    IPlatForm[IPlatForm["MINIAPP"] = 3] = "MINIAPP";
})(IPlatForm = exports.IPlatForm || (exports.IPlatForm = {}));
var IAccessChannel;
(function (IAccessChannel) {
    IAccessChannel[IAccessChannel["USER"] = 1] = "USER";
    IAccessChannel[IAccessChannel["DOCTOR"] = 2] = "DOCTOR";
})(IAccessChannel = exports.IAccessChannel || (exports.IAccessChannel = {}));
var IBizType;
(function (IBizType) {
    IBizType[IBizType["INNER_USER"] = 1] = "INNER_USER";
    IBizType[IBizType["INNER_DOCTOR"] = 2] = "INNER_DOCTOR";
    IBizType[IBizType["PRIVATE_USER"] = 3] = "PRIVATE_USER";
    IBizType[IBizType["PRIVATE_DOCTOR"] = 4] = "PRIVATE_DOCTOR";
    IBizType[IBizType["OUTTER_USER"] = 5] = "OUTTER_USER";
    IBizType[IBizType["OUTTER_DOCTOR"] = 6] = "OUTTER_DOCTOR";
})(IBizType = exports.IBizType || (exports.IBizType = {}));
//# sourceMappingURL=IContext.js.map